import useResourcesUniversitySpacesContext from "views/Recursos/ResourcesUniversitySpaces/utils/context/useResourcesUniversitySpacesContext";
import { TOAST_MESSAGES } from "../../../utils/constants";
import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
import { ACTION_TYPES } from "../constants";
import useMainContext from "utils/context/useMainContext";
import { wait } from "utils/others";
import ReservationErrorHandled from "../ReservationErrorHandled";

const useSaveReservationStudentInformation = ({
    updateActivityPopup,
	requests: {
		doRequestTakeStudentAttendance,
		doRequestPenalizeStudents,
		doRequestDeleteStudentFromReservationList,
		doRequestAddStudentToReservationList
	},
	actionTypeList
}) => {
    const mainContext = useMainContext();
    const { toastMessage, spaceList } = useResourcesUniversitySpacesContext();
    const dialogConfirm = useShowDialogAlert();
    async function saveInformation() {
        dialogConfirm.hide();
        const doAction = {
            [ACTION_TYPES.TAKE_ATTENDANCE]: doRequestTakeStudentAttendance,
            [ACTION_TYPES.PENALIZE]: doRequestPenalizeStudents,
            [ACTION_TYPES.DELETE]: doRequestDeleteStudentFromReservationList,
            [ACTION_TYPES.ADD]: doRequestAddStudentToReservationList
        };
        if (actionTypeList.noActions())
            return;
        try {
            for (const actionType of actionTypeList.value) {
                await doAction[actionType]();
            }
            updateActivityPopup.popup.hide();
            await wait(400);
            await spaceList.fill();
            toastMessage.show(TOAST_MESSAGES.SAVE_STUDENT_INFORMATION);
        }
        catch (error) {
            if (!(error instanceof ReservationErrorHandled))
                mainContext.setShowDialogUnexpectedError(true);
        }
    }
	return {
		dialogConfirm,
		saveInformation
	};
}	
	
export default useSaveReservationStudentInformation;